module.exports = __webpack_public_path__ + "img/contact.fdec4ee4.png";